import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FlatButton from 'material-ui/FlatButton';
import AppBar from 'material-ui/AppBar';
import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import Drawer from 'material-ui/Drawer';
import IconButton from 'material-ui/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import NavigationMenu from 'material-ui/svg-icons/navigation/menu';

import { logoutUser } from 'actions/users';
import { UserPerms } from 'store/configureStore';
import ListItem from 'material-ui/List/ListItem';
import List from 'material-ui/List/List';
import makeSelectable from 'material-ui/List/makeSelectable';
import helpers from 'helpers';

import './Header.scss';

const SelectableList = makeSelectable(List);

const options = {
    anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
    targetOrigin: { horizontal: 'left', vertical: 'top' },
};

const styles = {
    menuItem: {
        fontSize: '15px',
        minHeight: '36px',
        lineHeight: '36px',
    },
    btn: {
        style: { margin: '10px' },
        labelStyle: { fontSize: '12px' },
    },
};

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openDrawer: false,
            elTarget: null,
            isOpenPopover: false,
        };

        this.handlerUserLogout = this.handlerUserLogout.bind(this);
        this.handleToggleDrawer = this.handleToggleDrawer.bind(this);
        this.togglePopover = this.togglePopover.bind(this);
        this.closePopover = this.closePopover.bind(this);
        this.clearLocalStorage = this.clearLocalStorage.bind(this);
        this.onNavigate = this.onNavigate.bind(this);
    }

    togglePopover(e) {
        this.setState({
            isOpenPopover: !this.state.isOpenPopover,
            elTarget: e.target,
        });
    }

    handleToggleDrawer() {
        return this.setState({
            openDrawer: !this.state.openDrawer,
        });
    }

    handlerUserLogout(e) {
        e.preventDefault();
        this.props.logoutUser();
    }

    closePopover() {
        this.setState({
            isOpenPopover: !this.state.isOpenPopover,
            elTarget: null,
        });
    }

    clearLocalStorage() {
        localStorage.clear();
        this.closePopover();
    }

    onNavigate(e, uri) {
        if (!uri) return;
        this.props.router.push(uri);
        this.handleToggleDrawer();
    }

    render() {
        const { user } = this.props;
        const { isOpenPopover, elTarget, openDrawer } = this.state;

        function isAdmin() {
            return UserPerms.isAdmin();
        }

        const items = [
            { 
                uri: '/dev-only', 
                label: 'Розбійники', 
                accessCheck: () => helpers.isDevAllowed(user), 
                style: { color: 'red' },
            },
            { 
                uri: '/varamar-only', 
                label: 'Custom login (varamar)', 
                accessCheck: () => helpers.isDevAllowed(user, ['admin@varamar.com']), 
                style: { color: 'red' },
            },
            { uri: '/', label: 'Letters' },
            { uri: '/cargoes/assigners', label: 'Cargo editor' },
            { uri: '/cargoes/realnames', label: 'Cargo real names' },
            { uri: '/cargoes/duplicates', label: 'Duplicates' },
            { uri: '/cargoes/ldrates', label: 'Loading and discharging' },
            { uri: '/regions/altports', label: 'Ports' },
            { uri: '/regions/altareas', label: 'Areas' },
            { uri: '/regions/ports', label: 'Ports approve/reject' },
            { uri: '/flagCompliance', label: 'Flag compliance' },
            { uri: '/detentions', label: 'Detentions' },
            { uri: '/integrators/list', label: 'Integrators' },
            { uri: '/cargoes/requests', label: 'Cargo requests' },
            { uri: '/issues/list', label: 'Issue Reports' },
            { uri: '/tc/requests', label: 'Timecharter requests' },
            { uri: '/vessels/requests', label: 'Vessel requests' },
            { uri: '/vessels/claims', label: 'Vessel claims' },
            { uri: '/vessels/list', label: 'Vessel list' },
            { uri: '/vessels/sales', label: 'Vessel sales' },
            { uri: '/vessels/composition', label: 'Vessels composition' },
            { uri: '/tcIndex', label: 'Tc Index' },
            { uri: '/hires', label: 'Hires' },
            { uri: '/congestion', label: 'Congestion' },
            { uri: '/regions/merging', label: 'Merging' },
            { uri: '/regions/dashboard', label: 'Dashboard' },
            { uri: '/gazetteer-editor', label: 'Gazetteer editor' },
            {
                label: 'BBR',
                items: [
                    { uri: '/bbr/runs', label: 'Runs', accessCheck: isAdmin },
                    { uri: '/bbr/corporas', label: 'Corporas', accessCheck: () => helpers.isDevAllowed(user, ['oxidksushkin@gmail.com']) },
                ],
            },
            { uri: '/notifications/list', label: 'Notifications' },
            { uri: '/packing-list-recognition', label: 'Packing list', accessCheck: () => __DEV__ && isAdmin() },
            { 
                label: 'Statistics',
                accessCheck: isAdmin,
                items: [
                    { uri: '/statistics/vessel-updater', label: 'Vessel updater', accessCheck: isAdmin },
                    { uri: '/statistics/st', label: 'Analysts', accessCheck: isAdmin },
                    { uri: '/statistics/freight', label: 'Freight', accessCheck: () => __DEV__ && isAdmin() },
                ],
            },
            { 
                label: 'Statistics internal',
                accessCheck: isAdmin,
                items: [
                    { uri: '/statistics/queues', label: 'Statistics queues', accessCheck: isAdmin },
                ],
            },
            { uri: '/statistics/users', label: 'Statistics users', accessCheck: isAdmin },
            { uri: '/statistics/emails', label: 'Statistics emails', accessCheck: isAdmin },
            { uri: '/statistics/monitor', label: 'Statistics monitor', accessCheck: isAdmin },
            { uri: '/statistics/composition', label: 'Statistics composition', accessCheck: isAdmin },
            {
                label: 'Analytics',
                items: [
                    { uri: '/analytics/dashboard', label: 'Dashboard' },
                    { uri: '/analytics/mailers', label: 'Mailers' },
                ],
            },
            { uri: '/companies/realnames', label: 'Company real name', accessCheck: isAdmin },
            {
                label: 'Users',
                accessCheck: isAdmin,
                items: [
                    { uri: '/users/black-and-white-lists', label: 'Black and White Lists', accessCheck: isAdmin },
                    { uri: '/users/ban-list', label: 'Users list', accessCheck: isAdmin },
                    { uri: '/users/subscribers', label: 'Subscribers', accessCheck: isAdmin },
                    { uri: '/users/suspicious', label: 'Suspicious sessions', accessCheck: isAdmin },
                ],
            },
            
            { uri: '/sender/list', label: 'Sender email list', accessCheck: isAdmin },
            { uri: '/domains', label: 'Domains list', accessCheck: isAdmin },
            { uri: '/time-charter', label: 'Time Charter', accessCheck: isAdmin },
            { uri: '/disbursement', label: 'Disbursement', accessCheck: isAdmin },
            { uri: '/fuel', label: 'Fuel', accessCheck: isAdmin },
            { uri: '/pda', label: 'PDA', accessCheck: isAdmin },
            { uri: '/cargoes/requests/ldRates', label: 'L/D Rates', accessCheck: isAdmin },
        ];

        const userName = (
            <div onClick={this.togglePopover}>
                <Popover
                    open={isOpenPopover}
                    anchorEl={elTarget}
                    onRequestClose={this.closePopover}
                    anchorOrigin={options.anchorOrigin}
                    targetOrigin={options.targetOrigin}
                >
                    <RaisedButton
                        label='Delete local storage'
                        style={styles.btn.style}
                        labelStyle={styles.btn.labelStyle}
                        onClick={this.clearLocalStorage}
                        secondary
                    />
                </Popover>
                {`${user.email} ${user.role}`}
            </div>
        );

        return (
            <header>
                <AppBar
                    title={userName}
                    style={{ zIndex: 1 }}
                    iconElementLeft={
                        <IconButton onClick={this.handleToggleDrawer}>
                            <NavigationMenu onClick={this.handleToggleDrawer} />
                        </IconButton>
                    }
                    iconElementRight={
                        <FlatButton label='Logout' onClick={this.handlerUserLogout} />
                    }
                />

                <Drawer
                    docked={false}
                    width={200}
                    open={openDrawer}
                    onRequestChange={openDrawer => this.setState({ openDrawer })}
                >
                    <AppBar
                        title='MENU'
                        iconElementLeft={
                            <IconButton onClick={this.handleToggleDrawer}>
                                <NavigationClose onClick={this.handleToggleDrawer} />
                            </IconButton>
                        }
                    />
                    { newList(items, this.props.location.pathname, { onNavigate: this.onNavigate }) }
                </Drawer>

            </header>
        );
    }
}

function renderItem(item, location, ctx = { childSelected: false }) {
    if (item.accessCheck && !item.accessCheck()) {
        return null;
    }
    const props = {
        className: ['header-menu-item', item.className].filter(c => c).join(' '),
    };
    if (Array.isArray(item.items)) {
        props.nestedItems = item.items.map(i => renderItem(i, location, ctx)).filter(i => i);
        if (props.nestedItems.length === 0) {
            return null;
        }
    }
    if (item.uri == location) {
        ctx.childSelected = true;
    }
    if (ctx.childSelected) {
        props.initiallyOpen = true;
    }
    if (item.uri) {
        props.value = item.uri;
    } else {
        props.primaryTogglesNestedList = true;
    }

    props.innerDivStyle = {
        padding: '0 16px', lineHeight: '36px', fontSize: '15px', userSelect: 'none', 
    };

    if (item.innerStyle) {
        Object.assign(props.innerDivStyle, item.innerStyle);
    }

    if (item.style) {
        props.style = item.style;
    }

    // TODO: differentiate active/inactive ListItem with nested items
    // maybe render right instead of down arrow when uri and nestedItems provided
    return <ListItem key={item.uri || item.label} primaryText={item.label} {...props} />;
}

function menuLocation(items, location) {
    let selected = location;
    let selectedLength = -1;
    const visit = (list) => {
        for (const item of list) {
            if (item.uri && (location === item.uri || location.startsWith(`${item.uri}/`)) && item.uri.length > selectedLength) {
                selected = item.uri;
                selectedLength = item.uri.length;
            }
            if (Array.isArray(item.items)) {
                visit(item.items);
            }
        }
    };
    visit(items);
    return selected;
}

function newList(items, location, { onNavigate }) {
    const selected = menuLocation(items, location);
    return (<SelectableList value={selected} onChange={onNavigate} style={{ height: 'calc(100% - 64px)', overflowY: 'auto' }}>
        {items.map(item => renderItem(item, selected))}
            </SelectableList>);
}

export default connect(
    ({ user: { user } }) => ({
        user,
    }),
    dispatch => bindActionCreators(
        {
            logoutUser,
        },
        dispatch,
    ),
)(withRouter(Header));



// WEBPACK FOOTER //
// ./app/components/Layouts/Header.jsx